import { useState, useEffect } from "react";
import * as ReactDOM from "react-dom";

import { ModaqControl } from "../components/ModaqControl";
import { AUTH_TOKEN_KEY, LoginForm } from "@/components/LoginForm";
import { ROOM_NUMBER_KEY, MODERATOR_KEY, UNOFFICIAL_MODE_KEY } from "@/components/dialogs/NewGameDialog";

// This will be filled in by vite. This won't be used by people using the library
declare const __BUILD_VERSION__: string;

// If you want a different Google Sheets ID, replace this with your own
const demoGoogleClientId = "1038902414768-nj056sbrbe0oshavft2uq9et6tvbu2d5.apps.googleusercontent.com";
const demoYappService = "https://www.quizbowlreader.com/yapp/api/parse?modaq=true";


function App() {
    const [isAuthenticated, setIsAuthenticated] = useState<boolean | null>(null);

    useEffect(() => {
        const checkAuth = async () => {
            const token = localStorage.getItem(AUTH_TOKEN_KEY);
            const response = await fetch("/api/session", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ token }),
            });
            const data = await response.json();

            if (response.ok && data.success) {
                setIsAuthenticated(true);
            } else {
                setIsAuthenticated(false);
            }
        };

        checkAuth();
    }, []);

    if (isAuthenticated === null) {
        return null;
    }

    if (!isAuthenticated) {
        return <LoginForm onSuccess={() => setIsAuthenticated(true)} />;
    }

    return (
        <ModaqControl
            applyStylingToRoot={true}
            buildVersion={__BUILD_VERSION__}
            googleClientId={demoGoogleClientId}
            yappServiceUrl={demoYappService}
            customExport={{
                label: "Export",
                type: "QBJ",
                customExportInterval: 10000,
                onExport: (qbj: any, context: any) => {
                    if (localStorage.getItem(UNOFFICIAL_MODE_KEY) === "true") {
                        return Promise.resolve({ isError: false, status: "" });
                    }

                    const params = new URLSearchParams();
                    if (context.source) {
                        params.set("source", context.source);
                    }

                    const room = localStorage.getItem(ROOM_NUMBER_KEY);
                    if (room) {
                        params.set("room", room);
                    }

                    const moderator = localStorage.getItem(MODERATOR_KEY);
                    if (moderator) {
                        params.set("moderator", moderator);
                    }

                    const qs = params.toString();

                    fetch(`/api/games${qs ? `?${qs}` : ""}`, {
                        method: "POST",
                        body: JSON.stringify(qbj),
                        headers: { "Content-Type": "application/json" },
                    });

                    return Promise.resolve({ isError: false, status: "" });
                },
            }}
        />
    );
}

window.onload = () => {
    const element: HTMLElement | null = document.getElementById("root");
    if (element) {
        ReactDOM.render(<App />, element);
    }
};
